import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { KTSVG, toAbsoluteUrl } from '../../../../../../../../../_metronic/helpers';
import { putServiceOne } from '../../../../../../../../services/servicesService';
import { formatDateV4, formatDateV5OS, formatarData, formatarDataOS } from '../../../../../../../../utils/date';
import { linkPDF, linkPDFV2 } from '../../../../../../../../utils/savePDF';
import { useToast } from '../../../../../../../components/Toats';
import { NotImported } from '../../../../../../../components/NotInformat';
import { ModalDetailsClient } from '../../../../../../../clients/components/ModalDetailsClient';
import { ModalPlant } from '../../../../../../../components/modalPlant';
import { ModalPlantComposite } from '../../../../../../../components/modalPlantComposite';
import { ModalDetailsUnitBranch } from '../../../../../../../unit-branch/components/ModalDetailsUnitBranch';
import { ModalAddUpdateCollaborators } from '../../../../../../../collaborators/components/ModalAddEditCollaborator';
import { OSDateField } from '../../../../../../../components/orderServiceDetails/OSDateField';
import { OrderServiceStatusDropdown } from '../../../../../../../../components/OrderServiceChecklist/OrderServiceStatusDropdown';
import { OSFieldPickerModal } from '../../../../../../../components/orderServiceDetails/OSFieldPickerModal';
import { getClientAll } from '../../../../../../../../services/clientService';
import { getplantsAll } from '../../../../../../../../services/plantsService';
import { getUnitBranchAllSimple } from '../../../../../../../../services/unitBranchService';
import { getCollaboratosAll } from '../../../../../../../../services/collaboratorsService';
import { useAuth } from '../../../../../../../../modules/auth';
import { getFileBase64 } from '../../../../../../../../services/files';
import { getInvoicePDFFile } from '../../../../../../../../services/invoices';
import JSZip from 'jszip';
import { postConvertPdfV3 } from '../../../../../../../../services/ConvertPDFService';
import { getfileUrl } from '../../../../../../../../services/uploadService';
import useSize from '../../../../../../../../hooks/useSize';

type EditableField = 'client' | 'plant' | 'unitBranch' | 'collaborator'

type Props = {
  itemOrderOfService: any;
  refresh: any
}

export function ItemOSDetails({itemOrderOfService, refresh}: Props) {
  const [showCreateAppModalDetails, setShowCreateAppModalDetails] = useState<boolean>(false)
  const [showModalPlant, setShowModalPlant] = useState<boolean>(false)
  const [showModalUnitBranch, setShowModalUnitBranch] = useState<boolean>(false)
  const [showModalCollaborator, setShowModalCollaborator] = useState<boolean>(false)
  const [savingDateField, setSavingDateField] = useState<'dateInit' | 'dateEnd' | null>(null)
  const [editingField, setEditingField] = useState<EditableField | null>(null)
  const [loadingUpdateOS, setLoadingUpdateOS] = useState<boolean>(false)
  const [loadingPDF, setLoadingPDF] = useState<boolean>(false)
  const { toggleToast } = useToast();
  const {currentUser} = useAuth()
  const {width} = useSize()
  const isClientUser = currentUser?.role?.slug === 'CLIENTE'
  const plant = itemOrderOfService?.plant
  const unitBranch = itemOrderOfService?.unitBranch
  const collaborator = itemOrderOfService?.collaborators?.length > 0 ? itemOrderOfService.collaborators[0] : null

  const fieldPickers: Record<EditableField, {
    title: string
    icon: React.ReactNode
    searchPlaceholder: string
    currentId?: string | null
    labelKey: string
    sublabelKey?: string
    loadItems: () => Promise<any[]>
    buildBody: (id: string) => any
  }> = {
    client: {
      title: 'Alterar cliente',
      icon: <KTSVG path="/media/icons/duotune/communication/com006.svg" className="svg-icon-muted svg-icon-2"/>,
      searchPlaceholder: 'Buscar cliente',
      currentId: itemOrderOfService?.client?.id,
      labelKey: 'nameResponsible',
      sublabelKey: 'email',
      loadItems: () => getClientAll(unitBranch?.id ? unitBranch.id : ''),
      buildBody: (id) => ({ idClient: id }),
    },
    plant: {
      title: 'Alterar usina',
      icon: <img src={toAbsoluteUrl("/media/imgs/plant2.png")} height={20} alt=""/>,
      searchPlaceholder: 'Buscar usina',
      currentId: plant?.id,
      labelKey: 'name',
      sublabelKey: 'address',
      loadItems: () => getplantsAll(`?unitBranch=${unitBranch?.id ? unitBranch.id : ''}&collaborator=&client=`),
      buildBody: (id) => ({ idPlant: id }),
    },
    unitBranch: {
      title: 'Alterar unidade',
      icon: <KTSVG path="/media/icons/duotune/ecommerce/ecm009.svg" className="svg-icon-muted svg-icon-2"/>,
      searchPlaceholder: 'Buscar unidade',
      currentId: unitBranch?.id,
      labelKey: 'companyName',
      loadItems: () => getUnitBranchAllSimple(),
      buildBody: (id) => ({ idUnitBranch: id }),
    },
    collaborator: {
      title: 'Alterar colaborador',
      icon: <i className="bi bi-hammer fs-3 text-gray-500" />,
      searchPlaceholder: 'Buscar colaborador',
      currentId: collaborator?.id,
      labelKey: 'name',
      sublabelKey: 'email',
      loadItems: () => getCollaboratosAll(),
      buildBody: (id) => ({ idsCollaboratos: [id] }),
    },
  }

  const saveField = async (field: EditableField, id: string) => {
    if (!itemOrderOfService?.id) return
    try {
      await putServiceOne(itemOrderOfService.id, fieldPickers[field].buildBody(id))
      toggleToast("Sucesso ao atualizar a O.S. ", "success")
      refresh()
    } catch (error) {
      console.log(error)
      toggleToast("Erro ao atualizar a O.S. ", "error")
      throw error
    }
  }

  const renderEditButton = (field: EditableField) =>
    isClientUser ? null : (
      <button
        type='button'
        className='btn btn-icon btn-sm btn-light btn-active-light-primary ms-1 flex-shrink-0'
        style={{width: '1.9rem', height: '1.9rem'}}
        title={fieldPickers[field].title}
        onClick={() => setEditingField(field)}
      >
        <i className='bi bi-pencil fs-7' />
      </button>
    )

  const updateOSDate = async (field: 'dateInit' | 'dateEnd', value: string) => {
    if (!itemOrderOfService?.id) return
    try {
      setSavingDateField(field)
      await putServiceOne(itemOrderOfService.id, { [field]: value })
      toggleToast(field === 'dateInit' ? "Data de início atualizada. " : "Data de fim atualizada. ", "success")
    } catch (error) {
      console.log(error)
      toggleToast("Erro ao atualizar a data da O.S. ", "error")
    } finally {
      setSavingDateField(null)
      refresh()
    }
  }

  const getImage = async (key: string) => {
    try {
      const url = await getFileBase64(key)
      return url.base64

    } catch (error) {
      console.log(error)
      return ""
    }
  }

  const replaceValues = async (dados: any, html: string) => {
    let novoHtml = html;
    const imageCompany = dados 
        && dados.unitBranch 
        && dados.unitBranch.company 
        && dados.unitBranch.company.image 
        ? await getImage(dados.unitBranch.company.image)
        : "https://i.postimg.cc/kXzT1qjT/sua-logo-aqui.pngs";


    let dados_OS = {
        imageCompany: imageCompany ? `data:image/jpeg;base64,${imageCompany}` : "https://i.postimg.cc/kXzT1qjT/sua-logo-aqui.pngs",
        corporateName: dados && dados.unitBranch && dados.unitBranch.company && dados.unitBranch.company.corporateName ? dados.unitBranch.company.corporateName : "",
        cnpj: dados && dados.unitBranch && dados.unitBranch.company && dados.unitBranch.company.cnpj ? dados.unitBranch.company.cnpj : "",
        street: dados && dados.unitBranch && dados.unitBranch.street ? dados.unitBranch.street : "",
        district: dados && dados.unitBranch && dados.unitBranch.district ? dados.unitBranch.district : "",
        number: dados && dados.unitBranch && dados.unitBranch.number ? dados.unitBranch.number : "",
        telephone: dados && dados.unitBranch && dados.unitBranch.telephone ? dados.unitBranch.telephone : "",
        emailCompany: dados && dados.unitBranch && dados.unitBranch.emailCompany ? dados.unitBranch.emailCompany : "",
        number_order_service: dados && dados.number_order_service ? dados.number_order_service : "",
        dateCreate: dados && dados.created_at ? formatarData(dados.created_at) : "",
        nameResponsible: dados && dados.client && dados.client.nameResponsible ? dados.client.nameResponsible : "",
        cpfResponsible: dados && dados.client && dados.client.cpfResponsible ? dados.client.cpfResponsible : "",
        telephoneClient: dados && dados.client && dados.client.telephone ? dados.client.telephone : "0000-000",
        cellphoneClient: dados && dados.client && dados.client.cellphone ? dados.client.cellphone : "(00) 0 0000-0000",
        emailClient: dados && dados.client && dados.client.email ? dados.client.email : "",
        namePlant: dados && dados.plant && dados.plant.name ? dados.plant.name : "",
        addressPlant: dados && dados.plant && dados.plant.address ? dados.plant.address : "",
        titulo: dados && dados.title ? dados.title : "",
        status: dados && dados.status ? dados.status : "",
        description: dados && dados.description ? dados.description : "",
        addressService: dados && dados.address ? dados.address : "",
        companyName: dados && dados.unitBranch && dados.unitBranch.companyName ? dados.unitBranch.companyName : "",
        
        dateEnd: dados && dados.dateEnd ? formatDateV5OS(dados.dateEnd) : "",
        dateInit: dados && dados.dateInit ? formatDateV5OS(dados.dateInit) : "",
        //value_sub_final: dados && dados.value_sub_final ? dados.value_sub_final : "0",

        value_sub_final: dados && dados.value_sub_final && Number(dados.value_sub_final) > 0 
        ? dados.value_sub_final.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }).replace('R$', '').trim() 
        : '0,00',

        //value_discont: dados && dados.value_discont ? dados.value_discont : "0",

        value_discont: dados && dados.value_discont && Number(dados.value_discont) > 0 
        ? dados.value_discont.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }).replace('R$', '').trim() 
        : '0,00',

        //value_final: dados && dados.value_final ? dados.value_final : "0",

        value_final: dados && dados.value_final && Number(dados.value_final) > 0 
        ? dados.value_final.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }).replace('R$', '').trim() 
        : '0,00',
        
        nameCollaborator : dados && dados.collaborators && dados.collaborators.length > 0 && dados.collaborators[0].name ? dados.collaborators[0].name : "",
        telefoneCollaborator: dados && dados.collaborators && dados.collaborators.length > 0 && dados.collaborators[0].telephone ? dados.collaborators[0].telephone : "",
        emailCollaborator : dados && dados.collaborators && dados.collaborators.length > 0 && dados.collaborators[0].email ? dados.collaborators[0].email : "",

        itensServices: dados && dados.itensServices ? 
        dados.itensServices.map((item: any) => {
            const my_item = {
                service: item 
                ? item.tipo === "SERVICO" && item.typeService && item.typeService.description ? item.typeService.description 
                : item.tipo === "PRODUTO" && item.product && (item.product.name || item.product.description) ? (item.product.name || item.product.description) : ""
                : "",

                description: item && item.description ? item.description : "",
                
                //value: item && item.value ? item.value : "",
                value: item && item.value && Number(item.value) > 0 
                ? item.value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }).replace('R$', '').trim() 
                : '0,00',
                
                amount: item && item.amount ? item.amount : "",
                
                //sub_value: item && item.sub_value ? item.sub_value : "",

                sub_value: item && item.sub_value && Number(item.sub_value) > 0 
                ? item.sub_value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }).replace('R$', '').trim() 
                : '0,00',
            }
            return my_item
        }) : []

    }

    Object.keys(dados_OS).forEach(chave => {
        if(chave === 'itensServices'){
            const servicesHtml = dados_OS[chave].map((service: any) => {
                const tds = Object.keys(service).map(key => {
                  
                    if(key === 'sub_value' || key === 'value'){
                        return `<td>R$ ${service[key]}</td>`
                    }else{
                        return `<td>${service[key]}</td>`
                    }

                  //return `<td>${report[key]}</td>`;
                }).join('');
                return `<tr>${tds}</tr>`;
              }).join('');
    
              novoHtml = novoHtml.replace(
                `{{${chave}}}`,
                `<table style="width: 100%;">
                    <thead>
                        <tr>
                            <th class="bg-body">Serviço/Produto</th>
                            <th class="bg-body">Descrição</th>
                            <th class="bg-body">Valor Unit.</th>
                            <th class="bg-body">Qtd</th>
                            <th class="bg-body">Total</th>
                        </tr>
                    </thead>
                    <tbody id="table_services" style="color: rgb(31, 31, 31);">${servicesHtml}</tbody>
                  </table>` 
                // `<tbody id="table_services">${servicesHtml}</tbody>`
              );
        }else{
            const marcador = new RegExp(`{{${chave}}}`, 'g');
            novoHtml = novoHtml.replace(marcador, dados_OS[chave] );
        }
    });
    return novoHtml;
  }

  const updateOSOne = async (id: any, status: any) => {
    try {
      setLoadingUpdateOS(true)
      const body = {
        status: status
      }
      await putServiceOne(id, body)
      toggleToast("Sucesso ao atualizar a O.S. ", "success")
      //setClients(MyClient)

    } catch (error) {
      console.log(error)
      toggleToast("Erro ao atualizar a O.S. ", "error")
      
    }finally{
      setLoadingUpdateOS(false)
      refresh()
    }
}

const fetchHtmlAsString = async () => {
    try {
      const response = await axios.get('/media/HTMLs/template_OS.html', { responseType: 'text' });
      return response.data;
    } catch (error) {
      console.error('Error fetching HTML file:', error);
      return null;
    }
  };

// const previewPDF = async () => {
//     try {
//       setLoadingPDF(true)
//       //const template = await fetchHtmlAsString()
//       const template = itemOrderOfService 
//           && itemOrderOfService.templatesOS 
//           && itemOrderOfService.templatesOS.length > 0 
//           ? itemOrderOfService.templatesOS[0].textHTML 
//           : await fetchHtmlAsString();

//       const template_modificad = await replaceValues(itemOrderOfService, template)
//       const myReturnLink = await linkPDF(template_modificad ? template_modificad : "<h1>Template não encontrado! </h1>")
//       window.open(myReturnLink, '_blank');
      
//       //setUrl(myReturnLink) 
    
//     } catch (error) {
//       console.log(error)  
//     }finally{
//       setLoadingPDF(false)
//     }
//   }

    const processDocx = async (fileOrUrl: any, placeholders: any) => {
    try {
      let file;
  
      if (fileOrUrl && typeof fileOrUrl === "string") {

        const response: any = await getInvoicePDFFile(fileOrUrl);
          if (response) {
            const blob = response.data;
            file = new File([blob], "original-document.docx", { type: blob.type });
          }
      }
      
      if(file){
        const arrayBuffer = await file.arrayBuffer();
        const zip: any = await JSZip.loadAsync(arrayBuffer);
    
        const documentXml = await zip.file("word/document.xml").async("string");
        let updatedXml = documentXml;
    
        for (const [placeholder, value] of Object.entries(placeholders)) {
          const regex = new RegExp(`{{${placeholder}}}`, "g");
          updatedXml = updatedXml.replace(regex, value);
        }
  
        zip.file("word/document.xml", updatedXml);
        const updatedDocx = await zip.generateAsync({ type: "blob" });
    
        const pdfFormData = new FormData();
        pdfFormData.append("file", updatedDocx, "processed-document.docx");
    
        const response = await postConvertPdfV3(pdfFormData);
    
        const pdfBlob = new Blob([response.data], { type: "application/pdf" });
    
        const uploadFormData = new FormData();
        uploadFormData.append("file", pdfBlob, "final-document.pdf");
    
        const uploadResponse = await getfileUrl(uploadFormData);

        if (uploadResponse && uploadResponse.url) {
          let pdfUrl = uploadResponse.url;
    
          if(width && width < 1000){
            const url = new URL(pdfUrl);
            url.searchParams.append('open_external_app', 'true');
            pdfUrl = url.toString();
          }
          window.open(pdfUrl, '_blank', 'noopener,noreferrer');
        } else {
          console.error('Erro ao obter a URL do arquivo após o upload.');
        }
        console.log("Documento processado e convertido para PDF com sucesso!");
      }
    } catch (error) {
      console.error("Erro ao processar o documento:", error);
    }
    };

    const substituteValues = async (file: any, dados: any) => {
        if (file) {
        try {
            let placeholderData = {
            corporateName: dados && dados.unitBranch && dados.unitBranch.company && dados.unitBranch.company.corporateName ? dados.unitBranch.company.corporateName : "",
            cnpj: dados && dados.unitBranch && dados.unitBranch.company && dados.unitBranch.company.cnpj ? dados.unitBranch.company.cnpj : "",
            street: dados && dados.unitBranch && dados.unitBranch.street ? dados.unitBranch.street : "",
            district: dados && dados.unitBranch && dados.unitBranch.district ? dados.unitBranch.district : "",
            number: dados && dados.unitBranch && dados.unitBranch.number ? dados.unitBranch.number : "",
            telephone: dados && dados.unitBranch && dados.unitBranch.telephone ? dados.unitBranch.telephone : "",
            emailCompany: dados && dados.unitBranch && dados.unitBranch.emailCompany ? dados.unitBranch.emailCompany : "",
            number_order_service: dados && dados.number_order_service ? dados.number_order_service : "",
            dateCreate: dados && dados.created_at ? formatarData(dados.created_at) : "",
            nameResponsible: dados && dados.client && dados.client.nameResponsible ? dados.client.nameResponsible : "",
            cpfResponsible: dados && dados.client && dados.client.cpfResponsible ? dados.client.cpfResponsible : "",
            telephoneClient: dados && dados.client && dados.client.telephone ? dados.client.telephone : "0000-000",
            cellphoneClient: dados && dados.client && dados.client.cellphone ? dados.client.cellphone : "(00) 0 0000-0000",
            emailClient: dados && dados.client && dados.client.email ? dados.client.email : "",
            namePlant: dados && dados.plant && dados.plant.name ? dados.plant.name : "",
            addressPlant: dados && dados.plant && dados.plant.address ? dados.plant.address : "",
            titulo: dados && dados.title ? dados.title : "",
            status: dados && dados.status ? dados.status : "",
            description: dados && dados.description ? dados.description : "",
            addressService: dados && dados.address ? dados.address : "",
            companyName: dados && dados.unitBranch && dados.unitBranch.companyName ? dados.unitBranch.companyName : "",
            value_sub_final: dados && dados.value_sub_final ? dados.value_sub_final : "0",
            value_discont: dados && dados.value_discont ? dados.value_discont : "0",
            value_final: dados && dados.value_final ? dados.value_final : "0",
            ...(
                dados &&
                dados &&
                dados.itensProposal
                    ? dados.itensProposal.reduce((acc, item, index) => {
                        const idx = index + 1;
                        return {
                            ...acc,
                            [`itemDescription${idx}`]: item && item.description ? item.description : "",
                            [`itemService${idx}`]: item && item.tipo === "SERVICO" && item.typeService && item.typeService.description ? item.typeService.description : "",
                            [`itemProduct${idx}`]: item && item.tipo === "PRODUTO" && item.product && (item.product.name || item.product.description) ? (item.product.name || item.product.description) : "",
                            [`itemValue${idx}`]: item && item.value ? item.value : "",
                            [`itemAmount${idx}`]: item && item.amount ? item.amount : "",
                            [`itemSubValue${idx}`]: item && item.sub_value ? item.sub_value : "",
                        };
                    }, {})
                    : {}
            )
            };

            await processDocx(file, placeholderData);
        } catch (error) {
            console.error("Erro ao processar o documento:", error);
        }
        }
    }

    const previewPDF = async () => {
        try {
            setLoadingPDF(true)

            const myTemplate = itemOrderOfService 
            && itemOrderOfService.templatesOS 
            && itemOrderOfService.templatesOS.length > 0
            ? itemOrderOfService.templatesOS[0]
            : null

            if(myTemplate){
            if(myTemplate.typeDoc && myTemplate.typeDoc === 'html'){
                const templateHTML = itemOrderOfService 
                && itemOrderOfService.templatesOS 
                && itemOrderOfService.templatesOS.length > 0 
                ? itemOrderOfService.templatesOS[0].textHTML 
                : await fetchHtmlAsString();
    
                const template_modificad = await replaceValues(itemOrderOfService, templateHTML)
                //const myReturnLink = await linkPDF(template_modificad ? template_modificad : "<h1>Template não encontrado! </h1>")
                await linkPDFV2(template_modificad ? template_modificad : "<h1>Template não encontrado! </h1>")
                //window.open(myReturnLink, '_blank');
            }else{
                if(myTemplate.typeDoc && myTemplate.typeDoc === 'docx'){
                await substituteValues(myTemplate.linkDocx, itemOrderOfService)
                }
            }
            }
        } catch (error) {
        console.log(error)  
        }finally{
            setLoadingPDF(false)
        }
    }
    
  return (
    <div className='card card-flush p-7'>
      <div className='card-title' style={{display: 'flex', justifyContent: 'space-between'}}>
          <h3 className='align-items-start flex-column' style={{display: "flex"}}>
              <span className='card-label fw-bold fs-4'>
                  {itemOrderOfService && itemOrderOfService.title ? itemOrderOfService.title : "Sem Descrição"}
              </span>
          </h3>
          
          <div className='me-0 dropdown'>
              <button
                  //disabled={loadingAvaiable || loading || report ? !report.template ? true : false : true}
                  className='btn btn-lg text-hover-primary'
                  style={{padding: '0rem'}}
                  onClick={(event) => {
                      event.stopPropagation();
                  }}
                  //style={{width: largura < 1200 ? '100%' : '',display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '1rem'}}
                  type="button" id="dropdownMenuButton2" data-bs-toggle="dropdown" aria-expanded="false"
              >
              <i className='bi bi-three-dots fs-1'></i>

              </button>

              <img src="" alt="" />
          
              <div className='dropdown-menu w-150px w-md-150px dropdown-menu-end' aria-labelledby="dropdownMenuButton2" style={{padding: '1rem'}}>
                  <div className='card-toolbar nav nav-tabs' data-kt-buttons='true'>
                      <a
                          className={`btn btn-sm btn-color-muted px-5 me-1 nav-item`
                          }
                          style={{width: '100%'}}
                          data-bs-toggle="tab"
                          href="#"
                          aria-disabled={loadingPDF}
                          onClick={()=> {
                            previewPDF();
                          }}
                      >
                          Imprimir
                      </a>
                  </div>
              </div>
          </div>
      </div>
      <div className='separator separator-dashed border-gray-300 my-5'></div>

      <div className='card-body p-0' style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
          <div style={{display: 'flex', flexDirection: 'column', gap: '0.75rem'}}>
              <div style={{display: 'flex', alignItems: 'center', gap: '0.5rem'}}>
                  <div className='symbol symbol-45px flex-shrink-0'><span className='symbol-label bg-light border border-gray-300'><KTSVG path="/media/icons/duotune/communication/com006.svg" className="svg-icon-muted svg-icon-2x"/></span></div>
                  {itemOrderOfService && itemOrderOfService.client && itemOrderOfService.client.nameResponsible ? (
                    <a href="#"
                          className='text-primary fw-bold text-hover-muted d-block fs-5'
                          onClick={(event)=> {
                              event.preventDefault()
                              setShowCreateAppModalDetails(true)
                          }}
                      >
                              <h3>
                                  <span className='text-muted text-hover-secondary fw-semibold fs-6'>
                                      {itemOrderOfService.client.nameResponsible}
                                  </span>
                              </h3>
                      </a>
                  ) : (
                    <NotImported className='fs-6 text-gray-400 fw-semibold mb-0' />
                  )}
                  {renderEditButton('client')}
              </div>

              <div style={{display: 'flex', alignItems: 'center', gap: '0.5rem'}}>
                <div className='symbol symbol-45px flex-shrink-0'><span className='symbol-label bg-light border border-gray-300'><KTSVG path="/media/icons/duotune/files/fil002.svg" className="svg-icon-muted svg-icon-2x"/></span></div>
                <div style={{display: 'flex', flexDirection: 'column', gap: '0.4rem'}}>
                <OSDateField
                  label='Início'
                  value={itemOrderOfService?.dateInit}
                  editable={!isClientUser}
                  saving={savingDateField === 'dateInit'}
                  onSave={(value) => updateOSDate('dateInit', value)}
                />
                <OSDateField
                  label='Fim'
                  value={itemOrderOfService?.dateEnd}
                  editable={!isClientUser}
                  saving={savingDateField === 'dateEnd'}
                  onSave={(value) => updateOSDate('dateEnd', value)}
                />
                </div>
              </div>

              <div style={{display: 'flex', alignItems: 'center', gap: '0.5rem'}}>
                {/* <KTSVG path="/media/icons/duotune/files/fil002.svg" className="svg-icon-muted svg-icon-2hx"/> */}
                    {/* <img src={toAbsoluteUrl("media/imgs/plant2.png")} height={35}/> */}
                    <div className='symbol symbol-45px flex-shrink-0'><span className='symbol-label bg-light border border-gray-300'><img src={toAbsoluteUrl("/media/imgs/plant2.png")} height={26} alt=""/></span></div>

                  {plant && plant.name ? (
                    <a href="#"
                      className='d-block'
                      title='Ver detalhes da usina'
                      onClick={(event) => {
                        event.preventDefault()
                        setShowModalPlant(true)
                      }}
                    >
                      <h3 className='mb-0'>
                        <span className='text-primary text-hover-dark fw-semibold fs-6'>{plant.name}</span>
                      </h3>
                    </a>
                  ) : <NotImported className='fs-6 text-gray-400 fw-semibold mb-0' />}
                  {renderEditButton('plant')}
              </div>

              <div style={{display: 'flex', alignItems: 'center', gap: '0.5rem'}}>
                  <div className='symbol symbol-45px flex-shrink-0'><span className='symbol-label bg-light border border-gray-300'><KTSVG path="/media/icons/duotune/ecommerce/ecm009.svg" className="svg-icon-muted svg-icon-2x"/></span></div>
                  {unitBranch && unitBranch.companyName ? (
                    isClientUser ? (
                      <h3 className='mb-0'>
                        <span className='text-muted fw-semibold fs-6'>{unitBranch.companyName}</span>
                      </h3>
                    ) : (
                      <a href="#"
                        className='d-block'
                        title='Ver detalhes da unidade'
                        onClick={(event) => {
                          event.preventDefault()
                          setShowModalUnitBranch(true)
                        }}
                      >
                        <h3 className='mb-0'>
                          <span className='text-primary text-hover-dark fw-semibold fs-6'>{unitBranch.companyName}</span>
                        </h3>
                      </a>
                    )
                  ) : <NotImported className='fs-6 text-gray-400 fw-semibold mb-0' />}
                  {renderEditButton('unitBranch')}
              </div>

              <div style={{display: 'flex', alignItems: 'center', gap: '0.5rem'}}>
                    <div className='symbol symbol-45px flex-shrink-0'><span className='symbol-label bg-light border border-gray-300'><i className="bi bi-hammer fs-2x text-gray-500" /></span></div>
                        {/* <KTSVG path="/media/icons/duotune/files/fil002.svg" className={`svg-icon-muted svg-icon-${largura < 1200 ? "2x" : "2hx"}`}/> */}
                        <div className='d-flex align-items-center'>
                            {collaborator ? (
                              isClientUser ? (
                                <h3 style={{marginBottom: '0rem', paddingBottom: '0rem'}}>
                                  <span className='text-muted fw-semibold fs-6'>{collaborator.name}</span>
                                </h3>
                              ) : (
                                <a href="#"
                                  className='d-block'
                                  title='Ver colaborador'
                                  onClick={(event) => {
                                    event.preventDefault()
                                    setShowModalCollaborator(true)
                                  }}
                                >
                                  <h3 style={{marginBottom: '0rem', paddingBottom: '0rem'}}>
                                    <span className='text-primary text-hover-dark fw-semibold fs-6'>{collaborator.name}</span>
                                  </h3>
                                </a>
                              )
                            ) : <NotImported className='fs-6 text-gray-400 fw-semibold mb-0' />}
                            {renderEditButton('collaborator')}
                        </div>
                        
                    </div>

              <div style={{display: 'flex', alignItems: 'center', gap: '0.5rem'}}>
                  <div className='symbol symbol-45px flex-shrink-0'><span className='symbol-label bg-light border border-gray-300'><KTSVG path="/media/icons/duotune/maps/map001.svg" className="svg-icon-muted svg-icon-2x"/></span></div>
                      <OrderServiceStatusDropdown
                        id={`os-details-status-${itemOrderOfService?.id}`}
                        status={itemOrderOfService?.status}
                        canChange={!isClientUser}
                        loading={loadingUpdateOS}
                        fsBadge='7'
                        onChange={(status) => updateOSOne(itemOrderOfService.id, status)}
                      />
                      <h3>
                          <span className='text-muted fw-semibold fs-6'>
                              {/* {itemOrderOfService && itemOrderOfService.status ? itemOrderOfService.status : "Não identificado. "} */}
                              {/* <span 
                              className={
                                  `badge badge-light-${
                                      itemOrderOfService && itemOrderOfService.status && itemOrderOfService.status !== null
                                      ? itemOrderOfService.status === "AGUARDANDO"
                                      ? "primary"
                                      : itemOrderOfService.status === "CANCELADO"
                                      ? "danger"
                                      : itemOrderOfService.status === "FINALIZADO"
                                      ? "success"
                                      : itemOrderOfService.status === "AGENDADO"
                                      ? "info"
                                      : itemOrderOfService.status === "EM ANDAMENTO"
                                      ? "warning"
                                      : "secondary"
                                  : "secondary"
                                  } fs-7 fw-semibold`
                              }
                              >
                                  {
                                  itemOrderOfService && itemOrderOfService.status !== null ? itemOrderOfService.status : "Não identificado"
                                  }
                              </span> */}
                          </span>
                      </h3>
              </div>
          </div>
          {/* <div>
              <a
                  onClick={(event: any) => {
                      setShowModalDelete(true)
                      setMyOrderService(itemOrderOfService)
                  }}
                  href='#'
                  className='btn btn-icon btn-bg-secondary btn-active-color-primary btn-sm'
              >
                  <KTSVG
                      path='/media/icons/duotune/general/gen027.svg'
                      className='svg-icon-1'
                  />
              </a>
          </div> */}
      </div>

      {editingField && (
        <OSFieldPickerModal
          show={!!editingField}
          title={fieldPickers[editingField].title}
          icon={fieldPickers[editingField].icon}
          searchPlaceholder={fieldPickers[editingField].searchPlaceholder}
          currentId={fieldPickers[editingField].currentId}
          labelKey={fieldPickers[editingField].labelKey}
          sublabelKey={fieldPickers[editingField].sublabelKey}
          loadItems={fieldPickers[editingField].loadItems}
          onConfirm={(id) => saveField(editingField, id)}
          handleClose={() => setEditingField(null)}
        />
      )}

      <ModalDetailsClient
          show={showCreateAppModalDetails}
          id={itemOrderOfService && itemOrderOfService.client ? itemOrderOfService.client.id : undefined} 
          handleClose={() => {
            //setMyClient(null)
            setShowCreateAppModalDetails(false)
            //refresh()
          }} 
        />

      {plant && plant.id && plant.type_plant === 'COMPOSTA' && (
        <ModalPlantComposite
          show={showModalPlant}
          plant={showModalPlant ? plant.id : ''}
          handleClose={() => setShowModalPlant(false)}
        />
      )}

      {plant && plant.id && plant.type_plant !== 'COMPOSTA' && (
        <ModalPlant
          show={showModalPlant}
          plant={showModalPlant ? plant.id : ''}
          handleClose={() => setShowModalPlant(false)}
        />
      )}

      {unitBranch && unitBranch.id && !isClientUser && (
        <ModalDetailsUnitBranch
          show={showModalUnitBranch}
          id={unitBranch.id}
          handleClose={() => setShowModalUnitBranch(false)}
        />
      )}

      {collaborator && !isClientUser && (
        <ModalAddUpdateCollaborators
          show={showModalCollaborator}
          id={collaborator.id}
          data={collaborator}
          handleClose={() => {
            setShowModalCollaborator(false)
            refresh()
          }}
        />
      )}
    </div>
  );
}